import { render, staticRenderFns } from "./ShareTip.vue?vue&type=template&id=4ecc8ebe&scoped=true&"
import script from "./ShareTip.vue?vue&type=script&lang=js&"
export * from "./ShareTip.vue?vue&type=script&lang=js&"
import style0 from "./ShareTip.vue?vue&type=style&index=0&id=4ecc8ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc8ebe",
  null
  
)

export default component.exports